import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { GlobalVariable } from 'src/app/global';
import { BaseComponent } from 'src/app/models/base-component';
import { Util } from 'src/app/utils/utils';
import { PacientesService } from '../../services/pacientes/pacientes.service';
import { PopupConfirmacionComponent } from 'src/app/base/components/popup-confirmacion/popup-confirmacion.component';
import { ConfiguracionAplicacionCitasMedicasComponent } from 'src/app/base/components/configuracion-aplicacion-citas-medicas/configuracion-aplicacion-citas-medicas.component';
import { VentaComponent } from 'src/app/base/components/venta/venta.component';
import { PagoVentaComponent } from 'src/app/snapquick/components/pago-venta/pago-venta.component';
import { RegistroPacienteComponent } from '../registro-paciente/registro-paciente.component';
import { TratamientosService } from '../../services/tratamientos/tratamientos.service';
import { CitasMedicasService } from '../../services/citas-medicas/citas-medicas.service';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { RecetasComponent } from '../recetas/recetas.component';
import { KardexPacienteComponent } from '../kardex-paciente/kardex-paciente.component';

declare const aplicarPluginCalendario:any;
declare const resaltarPestañaMenu:any;
declare const FullCalendar:any;
declare const $:any;
declare const PDFDocument:any;
declare const blobStream:any;

@Component({
  selector: 'app-tratamientos',
  templateUrl: './tratamientos.component.html',
  styleUrls: ['./tratamientos.component.css']
})
export class TratamientosComponent extends BaseComponent implements OnInit {

  calendar:any;
  tratamiento:any={};
  historia_paciente:any;
  dato_paciente_lista:boolean=false;
  tipo_tratamiento:any;
  tratamientos:any[]=[];
  fichas_citas_medicas:any[]=[];
  clases_item_cita:any[]=['bgc-red-d1 text-white text-95','bgc-purple-d2 text-white text-95','bgc-blue-d1 text-white text-95','bgc-orange-d1 text-white text-95','bgc-pink-d1 text-white text-95','bgc-dark-d1 text-white text-95'];
  modalVenta:NgbModalRef;
  modalKardexPaciente:NgbModalRef;
  es_evento:boolean=true;
  searching = false;
  searchFailed = false;

  modal_registro_tratamiento:NgbModalRef;
	@ViewChild('modal_registro_tratamiento')
  private modal_registro_tratamiento_ref: TemplateRef<any>;

  modal_registro_historia_paciente:NgbModalRef;
	@ViewChild('modal_registro_historia_paciente')
  private modal_registro_historia_paciente_ref: TemplateRef<any>;

  modal_registro_receta:NgbModalRef;

  constructor(private router: Router,
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    private toastr: ToastrService,
    private pacientesService:PacientesService,
    private tratamientosService:TratamientosService,
    private citasMedicasService:CitasMedicasService) { 
      super(persistenciaService,modalService,generalService,usuarioService);
    }

  async ngOnInit(): Promise<void> {
    this.init();
		this.buscarAplicacion(this.router.url.substring(1));
		let fecha_actual=new Date();
    this.filter={
      gestion_actual:fecha_actual.getFullYear(),
		  mes_actual:fecha_actual.getMonth(),
      id_empresa:this.usuario.id_empresa,
      ids_sucursales_usuario:Util.obtenerIdsSucursales(this.usuario),
      sucursales:[{nombre:"TODOS",id:0}].concat(Util.obtenerSucursalesUsuario(this.usuario)),
      sucursal: {nombre:"TODOS",id:0},
      usuarios:[{nombre_usuario:"TODOS",id:0}],
      usuario: {nombre_usuario:"TODOS",id:0},
      tipos_tratamientos: [GlobalVariable.Dictionary.SELECCION_TODOS],
      tipo_tratamiento:GlobalVariable.Dictionary.SELECCION_TODOS,
      pacientes:[],
      fecha_historias:{
        year: fecha_actual.getFullYear(), 
        month: (fecha_actual.getMonth()+1),
        day:fecha_actual.getDate()
      }
    }
    await this.obtenerConfiguracionPagina(GlobalVariable.Dictionary.CODIGO_APP_TRATAMIENTOS);
    this.configurarCalendario();
    this.establecerFechas(this.filter.gestion_actual,this.filter.mes_actual);
    this.obtenerPacientes();
    this.obtenerTiposTratamiento();
    this.obtenerFichasHistoriasPacientes();
    this.column = "fecha_hora";
    this.getSearch(this.text_search,null);
  }

  ngAfterViewInit() {
		resaltarPestañaMenu(this.router.url.substring(1)+"1");
    aplicarPluginCalendario();
    this.configurarBotonesVista();
  }

  ocultarHorasVista(){
    $(".fc-timegrid-slots table tr:nth-child(-n+14)").css({display:"none"});
  }

  obtenerPacientes(){
    this.pacientesService.obtenerPacientesEmpresa(this.usuario.id_empresa).subscribe((res:any)=>{
      this.filter.pacientes=res;
    });
  }

  configurarCalendario(){
    let me=this;
    //for some random events to be added
	  var date = new Date();
	  var m = date.getMonth();
	  var y = date.getFullYear();
  
	  var day1 = Math.random() * 20 + 2;
	  var day2 = Math.random() * 25 + 1;
  
	// initialize the calendar
    this.calendar = new FullCalendar.Calendar(document.getElementById('calendar'), {
      themeSystem: 'bootstrap',
      headerToolbar: {
        start: 'today,prev,next',
        center: 'title',
        end: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      },
      businessHours: {
        // days of week. an array of zero-based day of week integers (0=Sunday)
        daysOfWeek: [1,2,3,4,5], // Monday - Friday

        startTime: Util.formatearHoraCadena(this.configuracion_pagina.object.datos.opciones_permisos.hora_trabajo_inicio.hour,this.configuracion_pagina.object.datos.opciones_permisos.hora_trabajo_inicio.minute,0), // a start time (10am in this example)
        endTime: Util.formatearHoraCadena(this.configuracion_pagina.object.datos.opciones_permisos.hora_trabajo_fin.hour,this.configuracion_pagina.object.datos.opciones_permisos.hora_trabajo_fin.minute,0), // an end time (6pm in this example)
      },
      allDayDefault: true,
      initialView: 'timeGridDay',
      locale: 'es',
      events: [],
      selectable: true,
      selectLongPressDelay: 200,
      contentHeight: 'auto',
      defaultTimedEventDuration:Util.formatearHoraCadena(this.configuracion_pagina.object.datos.opciones_permisos.duracion_cita.hour,this.configuracion_pagina.object.datos.opciones_permisos.duracion_cita.minute,0),
      slotDuration:Util.formatearHoraCadena(this.configuracion_pagina.object.datos.opciones_permisos.duracion_cita.hour,this.configuracion_pagina.object.datos.opciones_permisos.duracion_cita.minute,0),
      slotMinTime:Util.formatearHoraCadena(this.configuracion_pagina.object.datos.opciones_permisos.mostrar_horas_desde.hour,this.configuracion_pagina.object.datos.opciones_permisos.mostrar_horas_desde.minute,0),
      slotMaxTime:Util.formatearHoraCadena(this.configuracion_pagina.object.datos.opciones_permisos.mostrar_horas_hasta.hour,this.configuracion_pagina.object.datos.opciones_permisos.mostrar_horas_hasta.minute,0),
      select: function(date){
        me.tratamiento={
          id_empresa:me.usuario.id_empresa,
          paciente:{cliente:{}},
          fecha_hora:date.start,
          //tipo:me.filter.tipos_eventos.filter(t => t.nombre_corto=="RECGRUP")[0],
          fecha_texto:{day:date.start.getDate(),month:date.start.getMonth()+1,year:date.start.getFullYear()},
          hora_texto:{hour:date.start.getHours(),minute:date.start.getMinutes()},
          id_usuario:me.usuario.id
        }
        me.modal_registro_tratamiento=me.modalService.open(me.modal_registro_tratamiento_ref, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
        me.modal_registro_tratamiento.result.then((result) => {
          me.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          me.closeResult = `Dismissed ${me.getDismissReason(reason)}`;
        });
      }/*,
      eventContent: function(arg) { 
        return {
        html: '<div class="fc-event-time">'+arg.event.start.getHours()+':'+arg.event.start.getMinutes() +'</div><div class="fc-event-title">'+arg.event.title +'</div>'
        }
      }*/,
      editable: true,
      droppable: true,
      drop: function(info) {
        /*me.registroevento=me.modalService.open(me.registroeventoRef, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
        me.registroevento.result.then((result) => {
          me.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          me.closeResult = `Dismissed ${me.getDismissReason(reason)}`;
        });*/
      },
      eventClick: function(info) {
        me.es_evento=true;
        me.tratamiento = me.tratamientos.filter(cm => (cm.id==info.event.id))[0];
        me.tratamiento.fecha_hora=new Date(me.tratamiento.fecha_hora);
        me.tratamiento.fecha_texto={day:me.tratamiento.fecha_hora.getDate(),month:me.tratamiento.fecha_hora.getMonth()+1,year:me.tratamiento.fecha_hora.getFullYear()},
        me.tratamiento.hora_texto={hour:me.tratamiento.fecha_hora.getHours(),minute:me.tratamiento.fecha_hora.getMinutes()},
        me.modal_registro_tratamiento=me.modalService.open(me.modal_registro_tratamiento_ref, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
        me.modal_registro_tratamiento.result.then((result) => {
          me.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          me.closeResult = `Dismissed ${me.getDismissReason(reason)}`;
        });
      },
      datesSet: function (dateInfo) {
        var view = dateInfo.view;
        //console.log(dateInfo);
      }
    
    });
	  this.calendar.render();
  }  

  configurarBotonesVista(){
	  let me=this;
    /*$('.fc-timeGridDay-button').click(function(){
      me.ocultarHorasVista();
      setTimeout(function(){
        me.getItems();
      },1000);
		});

    $('.fc-timeGridWeek-button').click(function(){
      me.ocultarHorasVista();
      setTimeout(function(){
        me.getItems();
      },1000);
		});*/

		/*$('.fc-prev-button').click(function(){
			if(me.filter.mes_actual==0){
				me.filter.mes_actual=11;
				me.filter.gestion_actual--;
			}
			else{
				me.filter.mes_actual--;
			}		   
      me.establecerFechas(me.filter.gestion_actual,me.filter.mes_actual);
		  me.getItems();
		});

		$('.fc-next-button').click(function(){			
			if(me.filter.mes_actual==11){
				me.filter.mes_actual=0;
				me.filter.gestion_actual++;
			}
			else{
				me.filter.mes_actual++;
			}		   
			me.establecerFechas(me.filter.gestion_actual,me.filter.mes_actual);
		  me.getItems();
		});*/
	}

  establecerFechas(gestion_actual,mes_actual){
    let fecha_inicio_mes=new Date(gestion_actual,mes_actual,1);
    let fecha_fin_mes=new Date(gestion_actual,mes_actual+1,0);
    this.filter.fecha_inicio={
      year: fecha_inicio_mes.getFullYear(), 
      month: (fecha_inicio_mes.getMonth()+1),
      day:fecha_inicio_mes.getDate()
    };
    this.filter.fecha_fin={
      year: fecha_fin_mes.getFullYear(), 
      month: (fecha_fin_mes.getMonth()+1),
      day:fecha_fin_mes.getDate()
    }
  }

  cambiarPresentacionPaciente(){
    this.dato_paciente_lista=!this.dato_paciente_lista;
  }

  async obtenerTiposTratamiento(){
		this.tipo_tratamiento=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_TRATAMIENTOS_MEDICOS).toPromise();
	}

  guardarTratamiento(){
    if(this.validarRegistroTratamiento()){
      this.blockUI.start();
      this.tratamiento.fecha_hora=Util.convertirObjetoAfecha(this.tratamiento.fecha_texto);
      this.tratamiento.fecha_hora.setHours(this.tratamiento.hora_texto.hour);
      this.tratamiento.fecha_hora.setMinutes(this.tratamiento.hora_texto.minute);
      if(this.tratamiento.id){
        this.tratamientosService.actualizarTratamiento(this.tratamiento).subscribe((res:any)=>{
          this.blockUI.stop();
          this.modal_registro_tratamiento.close();
          if(res.tiene_error){
            this.toastr.error(res.mensaje);
          }else{
            this.toastr.success(res.mensaje);
            this.getItems();
          }
        });
      }else{
        this.tratamientosService.guardarTratamiento(this.tratamiento).subscribe((res:any)=>{
          this.blockUI.stop();
          this.modal_registro_tratamiento.close();
          if(res.tiene_error){
            this.toastr.error(res.mensaje);
          }else{
            this.toastr.success(res.mensaje);
            this.getItems();
          }
        });
      }
    }
  }

  validarRegistroTratamiento(){
    let res=true;
    if(!this.tratamiento.paciente || (this.tratamiento.paciente && !this.tratamiento.paciente.id)){
      res=res && false;
      this.toastr.error("Debe especificar el paciente!");
    }
    if(!this.tratamiento.tipo){
      res=res && false;
      this.toastr.error("Debe especificar el tipo de tratamiento!");
    }
    if(!this.tratamiento.fecha_texto || !this.tratamiento.fecha_texto.year || !this.tratamiento.fecha_texto.month || !this.tratamiento.fecha_texto.day){
      res=res && false;
      this.toastr.error("Debe especificar la fecha completa para la cita médica!");
    }
    if(!this.tratamiento.hora_texto || (this.tratamiento.hora_texto.hour==null || this.tratamiento.hora_texto.hour==undefined) || (this.tratamiento.hora_texto.minute==null || this.tratamiento.hora_texto.minute==undefined)){
      res=res && false;
      this.toastr.error("Debe especificar la hora completa para la cita médica!");
    }
    return res;
  }

  async getItems(){
    this.blockUI.start();
    let eventos_source:any[] = this.calendar.getEvents();
		eventos_source.forEach(event => {
			event.remove();
		});
    this.tratamientosService.obtenerListaTratamientos(this).subscribe((tratamientos:any)=>{
      this.blockUI.stop();
      this.tratamientos=tratamientos;
      for(var i=0;i<tratamientos.length;i++){
        let fecha_cita=new Date(tratamientos[i].fecha_hora);
        let tratamiento_calendario:any={
            id:tratamientos[i].id,
            title: (tratamientos[i].paciente.cliente.persona.nombres+" "+(tratamientos[i].paciente.cliente.persona.apellido_paterno?tratamientos[i].paciente.cliente.persona.apellido_paterno:"")+" "+(tratamientos[i].paciente.cliente.persona.apellido_materno?tratamientos[i].paciente.cliente.persona.apellido_materno:""))
        }
        tratamiento_calendario.start=fecha_cita;
        //cita_medica_calendario.end=new Date(fecha_cita).setMinutes(fecha_cita.getMinutes()+15);
        //}
        tratamiento_calendario.className=tratamientos[i].consolidado?"bgc-success-d1 text-white text-95":(tratamientos[i].tipo.nombre.toUpperCase()=="CONSULTA"?'bgc-blue-d1 text-white text-95':'bgc-orange-d1 text-white text-95');
        this.calendar.addEvent(tratamiento_calendario);
      }
      //$('#'+$scope.idCalendario).fullCalendar('addEventSource',$scope.pedidos_calendario);
    });
	}

  async obtenerFichasHistoriasPacientes(){
    this.blockUI.start();
    this.tratamientosService.obtenerFichasHistoriasPacientes(this).subscribe((fichas_citas_medicas:any)=>{
      this.blockUI.stop();
      this.fichas_citas_medicas=fichas_citas_medicas;
    });
	}

  abrirModalRegistroHistoriaPaciente(tratamiento){
    this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de asignar ficha a la historia de paciente?";
		this.popupConfirmacion.componentInstance.data = tratamiento;
		
		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
				this.guardarHistoriaPaciente(tratamiento);
			}
			this.popupConfirmacion.close();
    });
  }

  guardarHistoriaPaciente(tratamiento){
    this.historia_paciente=tratamiento.historia_paciente?tratamiento.historia_paciente:{
      tratamiento:tratamiento,
      paciente:tratamiento.paciente,
      numero_paginas:1,
      id_sucursal:this.usuario.sucursalesUsuario[0].id_sucursal,
      id_usuario:this.usuario.id
    };
    this.historia_paciente.tratamiento=this.historia_paciente.tratamiento?this.historia_paciente.tratamiento:JSON.parse(JSON.stringify(tratamiento));
    if(this.validarHistoriaPaciente()){
      this.blockUI.start();
      if(this.historia_paciente.id){
        this.citasMedicasService.actualizarHistoriaPaciente(this.historia_paciente).subscribe((res:any)=>{
          this.blockUI.stop();
          this.toastr.success(res.mensaje);
          this.modal_registro_tratamiento.close();
          this.getItems();
          this.obtenerFichasHistoriasPacientes();
        });
      }else{
        this.citasMedicasService.guardarHistoriaPaciente(this.historia_paciente).subscribe((res:any)=>{
          this.blockUI.stop();
          this.toastr.success(res.mensaje);
          this.modal_registro_tratamiento.close();
          this.getItems();
          this.obtenerFichasHistoriasPacientes();
        });
      }
    }
  }

  validarHistoriaPaciente(){
    let res=true;
    if(!this.historia_paciente.numero_paginas){
      res=res && false;
      this.toastr.error("Debe especificar el número de paginas!");
    }
    return res;
  }

  abrirPopupConfirmacionEliminacion(tratamiento){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de anular el tratamiento?";
		this.popupConfirmacion.componentInstance.data = tratamiento;
		
		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
				this.eliminarTratamiento($e.data);
			}
			this.popupConfirmacion.close();
    });
	}

  eliminarTratamiento(tratamiento){
		this.blockUI.start();
		this.tratamientosService.eliminarTratamiento(tratamiento).subscribe((res:any) => {
      if(this.modal_registro_tratamiento){
        this.modal_registro_tratamiento.close();
      }
			this.toastr.success(res.mensaje);
			this.getItems();
      this.obtenerFichasHistoriasPacientes();
			this.blockUI.stop();
		});
	}

  abrirConfiguracionAplicacion(){
		this.configuracion_aplicacion_modal=this.modalService.open(ConfiguracionAplicacionCitasMedicasComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static',scrollable:true});
		this.configuracion_aplicacion_modal.componentInstance.configuracion_pagina=this.configuracion_pagina;
		this.configuracion_aplicacion_modal.componentInstance.usuario=this.usuario;
		this.configuracion_aplicacion_modal.componentInstance.alTerminar.subscribe((res) => {
			this.configuracion_aplicacion_modal.close();
		});
	}

  async generarVentaTratamiento(tratamiento){
    if(tratamiento.tipo.nombre_corto && parseFloat(tratamiento.tipo.nombre_corto)>0){
      this.blockUI.start();
		  let configuracion_aplicacion_ventas:any=await this.usuarioService.obtenerConfiguracionPaginaPorCodigo(this.usuario.id_empresa,GlobalVariable.Dictionary.CODIGO_APP_VENTAS,this.usuario.empresa.usar_permisos_avanzados_usuarios?this.usuario.id:0).toPromise();
		  this.modalVenta = this.modalService.open(VentaComponent, {windowClass:'venta-popup', ariaLabelledBy: 'modal-basic-title',size: 'lg', backdrop: 'static'});
			this.modalVenta.componentInstance.venta.usuario = this.usuario;
			this.modalVenta.componentInstance.usuario = this.usuario;
			this.modalVenta.componentInstance.configuracion_pagina = configuracion_aplicacion_ventas;
			this.modalVenta.componentInstance.venta.sucursales = Util.obtenerSucursalesUsuario(this.usuario);
			this.modalVenta.componentInstance.es_administrador=Util.esUsuarioAdministrador(this.usuario);
			this.modalVenta.componentInstance.venta.cliente=tratamiento.paciente.cliente;
			this.modalVenta.componentInstance.venta.sucursal=Util.obtenerSucursalesUsuario(this.usuario)[0];
			this.modalVenta.componentInstance.nombre_corto_canal_directo=this.global_variable.Dictionary.CANAL_VENTA_DIRECTA;
      this.modalVenta.componentInstance.venta.descontar_almacen=this.usuario.empresa.usar_inventario?true:false;
      this.modalVenta.componentInstance.venta.id_historia_paciente=tratamiento.historia_paciente.id;
      this.modalVenta.componentInstance.venta.pagado=parseFloat(tratamiento.tipo.nombre_corto);
			this.modalVenta.componentInstance.venta.detallesVenta=[{
          descripcion:tratamiento.tipo.nombre,
          precio_unitario:parseFloat(tratamiento.tipo.nombre_corto),
          importe:parseFloat(tratamiento.tipo.nombre_corto),
          total:parseFloat(tratamiento.tipo.nombre_corto),
          es_servicio:true,
          es_combo:false,
          item:GlobalVariable.Dictionary.ITEM_SERVICIO,
          editar_precio:true,
          cantidad:1,descuento:0,tipo_descuento:false
        }];
	
			this.modalVenta.componentInstance.inhabilitar_busqueda_item=false;
			this.modalVenta.componentInstance.inhabilitar_sucursal=true;
			this.modalVenta.componentInstance.inhabilitar_almacen=true;
			this.modalVenta.componentInstance.inhabilitar_descontar_almacen=true;
			this.blockUI.stop();
			this.modalVenta.componentInstance.alTerminar.subscribe((res) => {
				if(res){
					if(res.tiene_error){
						this.toastr.error(res.mensaje);
						this.toastr.error(res.stack.substring(0,500));
					}else{
            this.obtenerFichasHistoriasPacientes();
						this.toastr.success(res.mensaje);
						//this.imprimirVenta(res.venta.id,true);
						this.modalVenta.close();
					}
				}else{
					this.modalVenta.close();
				}
				
			});
    }else{
      this.toastr.warning("Parámetro economico no definido o no permitido!");
    }
  }

  generarPdfHistoriaPaciente(cita_medica){
    var doc = new PDFDocument({margin:10,size:GlobalVariable.Dictionary.PAPEL_CARTA_MEDIDA});
    var stream = doc.pipe(blobStream());
    let fecha_inicio=new Date();
    let fecha_fin=new Date();
    fecha_fin.setDate(fecha_inicio.getDate()+365-1);
    doc.font('Helvetica',10);
    doc.fillColor("blue");
    doc.text("DR. HENRY MORUNO CRUZ MEDICO REUMATOLOGO"/*this.usuario.empresa.nombre*/,231,30,{width:150,align:"center"});
    doc.font('Helvetica-Bold',23);
    doc.fillColor("black");
    doc.text("HISTORIA CLINICA",0,60,{align:"center"});
    doc.font('Helvetica-Bold',12);
    doc.text("NOMBRE:",50,90);
    doc.text("EDAD: ",50,110);
    doc.text("TELEFONO: ",50,130);
    doc.text("FECHA:",450,90);
    doc.text(cita_medica.historia_paciente.numero_paginas,550,30);
    doc.text("--------------------------------------------------------------------------------------------------------------------------------",0,140,{align:'center'});
    doc.font('Helvetica',12);
    let texto_nombre=(cita_medica.paciente.cliente.persona.nombres+" "+(cita_medica.paciente.cliente.persona.apellido_paterno?cita_medica.paciente.cliente.persona.apellido_paterno:"")+" "+(cita_medica.paciente.cliente.persona.apellido_materno?cita_medica.paciente.cliente.persona.apellido_materno:""));
    doc.text(texto_nombre.toUpperCase(),120,90);
    doc.text((Util.calcularEdad(cita_medica.paciente.cliente.persona.fecha_nacimiento))+" Años",120,110);
    let telefono=(cita_medica.paciente.cliente.persona.telefono?cita_medica.paciente.cliente.persona.telefono+"-":"")+(cita_medica.paciente.cliente.persona.telefono_movil?cita_medica.paciente.cliente.persona.telefono_movil:"");
    doc.text(telefono,120,130);
    let fecha_hoy=new Date();
    doc.text((fecha_hoy.getDate()+"-"+(fecha_hoy.getMonth()+1)+"-"+fecha_hoy.getFullYear()),500,90);
    doc.end();

    stream.on('finish', function () {
      var fileURL = stream.toBlobURL('application/pdf');
      var w = window.open(fileURL, '_blank', 'location=no');
      setTimeout(function () {
        w.print();
      }, 500);
    });
  }

  crearPagoVenta(tratamiento){
		this.modalVenta = this.modalService.open(PagoVentaComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
		this.modalVenta.componentInstance.venta = {id:tratamiento.historia_paciente.id_venta};
		this.modalVenta.componentInstance.usuario = this.usuario;
		this.modalVenta.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
					this.toastr.success(res.mensaje);
					this.obtenerFichasHistoriasPacientes();
					this.modalVenta.close();
				}
			}else{
				this.modalVenta.close();
			}
			
		});
  }

  modificarTratamiento(tratamiento){
    this.es_evento=false;
    this.tratamiento=tratamiento;
    this.tratamiento.fecha_hora=new Date(this.tratamiento.fecha_hora);
    this.tratamiento.fecha_texto={day:this.tratamiento.fecha_hora.getDate(),month:this.tratamiento.fecha_hora.getMonth()+1,year:this.tratamiento.fecha_hora.getFullYear()},
    this.tratamiento.hora_texto={hour:this.tratamiento.fecha_hora.getHours(),minute:this.tratamiento.fecha_hora.getMinutes()},
    this.modal_registro_tratamiento=this.modalService.open(this.modal_registro_tratamiento_ref, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modal_registro_tratamiento.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  crearNuevoPaciente(){
		this.modalVenta = this.modalService.open(RegistroPacienteComponent, { ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
			this.modalVenta.componentInstance.usuario = this.usuario;
			this.modalVenta.componentInstance.alTerminar.subscribe((res) => {
				if(res){
					if(res.tiene_error){
						
					}else{
            this.obtenerPacientes();
            this.tratamiento.paciente=res.paciente;
						this.modalVenta.close();
					}
				}else{
					this.modalVenta.close();
				}
				
			});
  }

  buscarPaciente = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
	  switchMap( (term) =>  this.pacientesService.buscarPaciente(this.usuario.id_empresa,term)),
	  catchError(() => {
		this.searchFailed = true;
		return of([]);
	  })  ,
      tap(() => this.searching = false)
	)
	
  formatter = (x: any) => (x.id?(x.cliente.identificacion?x.cliente.identificacion:""):"");

  establecerPaciente(event){
    let paciente=(event.id)?event:event.item;
    this.tratamiento.paciente_texto=paciente.cliente.idetificacion;
    this.tratamiento.paciente=paciente;
  }

  reiniciarPaciente(){
    this.tratamiento.paciente={cliente:{}};
    this.tratamiento.paciente_texto=null;
    $("#paciente_texto").val("");
  }

  modificarPaciente(paciente){
		this.modalVenta = this.modalService.open(RegistroPacienteComponent, { ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
			this.modalVenta.componentInstance.usuario = this.usuario;
      this.modalVenta.componentInstance.paciente = paciente;
			this.modalVenta.componentInstance.alTerminar.subscribe((res) => {
				if(res){
					if(res.tiene_error){
						
					}else{
            this.obtenerPacientes();
            this.tratamiento.paciente=res.paciente;
						this.modalVenta.close();
					}
				}else{
					this.modalVenta.close();
				}
				
			});
  }

  verKardexPaciente(paciente){
    this.modalKardexPaciente = this.modalService.open(KardexPacienteComponent, { windowClass:'kardex-paciente', ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modalKardexPaciente.componentInstance.usuario = this.usuario;
    this.modalKardexPaciente.componentInstance.paciente = paciente;
    this.modalKardexPaciente.componentInstance.alTerminar.subscribe((res) => {
      this.modalKardexPaciente.close();
    });
  }

  async abrirModalRegistroReceta(historia_paciente,paciente){
    this.blockUI.start();
    let recetas:any=await this.pacientesService.obtenerReceta(historia_paciente.id).toPromise();
    historia_paciente.recetas=recetas;
    this.blockUI.stop();
    this.modal_registro_receta=this.modalService.open(RecetasComponent, {windowClass:'receta-paciente',size:"md",ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modal_registro_receta.componentInstance.receta =  {
      id_historia_paciente:historia_paciente.id,
      id_usuario:this.usuario.id,
      activo:true
    };
    this.modal_registro_receta.componentInstance.historia_paciente = historia_paciente;
    this.modal_registro_receta.componentInstance.paciente = paciente;
    this.modal_registro_receta.componentInstance.alTerminar.subscribe((res) => {
      this.modal_registro_receta.close();
    });
  }

}
